<div class="statistics-wrapper">
  @if(statistics) {
  <div class="box">
    <span>Users</span>
    <span>{{ statistics.free + statistics.premium }}</span>
  </div>
  <div class="box">
    <span>Monthly</span>
    <span>{{ statistics.monthly | number : "1.0-2" }} Ft</span>
  </div>
  <div class="box">
    <span>Total</span>
    <span>{{ statistics.total | number : "1.0-2" }} Ft</span>
  </div>
  }
</div>
